import type { User } from '@entities/user';
import { Flex, ThemeIcon, Title } from '@mantine/core';
import { useMemo } from 'react';
import { UserSintiaChatReadonlyMessageList } from './user-sintia-chat-readonly-message-list';
import { UserSintiaChatMessageInput } from './UserSintiaChatMessageInput';
import { useUserSintiaChat } from './useUserSintiaChat';
import { IconChecks } from '@tabler/icons-react';

type UserSintiaChatReadonlyProps = {
  user: User;
};

export const UserSintiaChatReadonly = ({
  user,
}: UserSintiaChatReadonlyProps) => {
  const employerDisplayName = useMemo(() => {
    const name = [user.profile.firstName, user.profile.lastName]
      .filter(Boolean)
      .join(' ')
      .trim();
    return name || 'Пользователь';
  }, [user.profile.firstName, user.profile.lastName]);
  const chat = useUserSintiaChat(user.id, employerDisplayName);

  return (
    <Flex direction='column' gap={12} w='100%'>
      <Flex gap={16}>
        <ThemeIcon size={36} bg='green.0' radius={100}>
          <IconChecks size={24} color='var(--mantine-color-green-7)' />
        </ThemeIcon>
        <Title order={4}>Диалог с Синтией</Title>
      </Flex>
      <UserSintiaChatReadonlyMessageList chat={chat} />
      <UserSintiaChatMessageInput
        sendMessage={chat.sendMessage}
        isSending={chat.isSending}
      />
    </Flex>
  );
};
